import { httpRequest } from '@/api/httpClient'

export const imageApi = {
  generate(payload) {
    return httpRequest('/api/image', { method: 'POST', body: payload })
  },
  fission(payload) {
    return httpRequest('/api/fission', { method: 'POST', body: payload })
  },
  removeBg(payload) {
    return httpRequest('/api/remove-bg', { method: 'POST', body: payload })
  },
  downloadZip(payload) {
    return httpRequest('/api/download-zip', { method: 'POST', body: payload, responseType: 'blob' })
  },
  combineSizeChart(payload) {
    return httpRequest('/api/combine-size-chart', { method: 'POST', body: payload })
  }
}
